<template>
  <el-form ref="form" :model="onRoadForm" :rules="rules" label-width="200px">
    <el-row>
      <el-col :span="8">
        <el-form-item label="检测报告编号" prop="report_number">
          <el-input v-model="onRoadForm.report_number" clearable placeholder="请输入检测报告编号" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="检测日期" prop="inspection_date">
          <el-date-picker
            v-model="onRoadForm.inspection_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择检测日期"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-divider content-position="center">基本信息</el-divider>
    </el-col>

    <el-row>
      <el-form-item label="检测地点" prop="inspection_location_address">
        <el-col :span="8">
          <el-cascader
            v-model="onRoadForm.inspection_location"
            size="medium"
            :options="pcTextArr"
            style="width: 100%;"
          />
        </el-col>
        <el-col :span="8">
          <el-input v-model="onRoadForm.inspection_location_address" style="margin-left: 10px;" clearable placeholder="请输入详细地址" />
        </el-col>
      </el-form-item>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="号牌号码" prop="license_plate_number">
          <el-input v-model="onRoadForm.license_plate_number" clearable placeholder="请输入号牌号码" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="车辆型号" prop="vehicle_model">
          <el-input v-model="onRoadForm.vehicle_model" clearable placeholder="请输入车辆型号" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="基准质量（kg）" prop="base_mass">
          <el-input v-model="onRoadForm.base_mass" type="number" clearable placeholder="请输入基准质量" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-form-item label="车辆识别代码（VIN）" prop="vehicle_identification_number">
          <el-input v-model="onRoadForm.vehicle_identification_number" clearable placeholder="请输入车辆识别代码" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="最大设计总质量（kg）" prop="max_design_mass">
          <el-input v-model="onRoadForm.max_design_mass" clearable placeholder="请输入最大设计总质量" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="发动机型号" prop="engine_model">
          <el-input v-model="onRoadForm.engine_model" clearable placeholder="请输入发动机型号" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="发动机号码" prop="engine_number">
          <el-input v-model="onRoadForm.engine_number" clearable placeholder="请输入发动机号码" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="发动机排量（L）" prop="engine_displacement">
          <el-input v-model="onRoadForm.engine_displacement" type="number" clearable placeholder="请输入发动机排量" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="额定转速(r/min)" prop="rated_speed">
          <el-input v-model="onRoadForm.rated_speed" type="number" clearable placeholder="请输入额定转速" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="发动机额定功率(kW)" prop="rated_power">
          <el-input v-model="onRoadForm.rated_power" type="number" clearable placeholder="请输入发动机额定功率" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="DPF" prop="dpf">
          <el-input v-model="onRoadForm.dpf" clearable placeholder="请输入DPF" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="DPF型号" prop="dpf_model">
          <el-input v-model="onRoadForm.dpf_model" clearable placeholder="请输入DPF型号" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="SCR" prop="scr">
          <el-input v-model="onRoadForm.scr" clearable placeholder="请输入SCR" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="SCR型号" prop="scr_model">
          <el-input v-model="onRoadForm.scr_model" clearable placeholder="请输入SCR型号" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="气缸数" prop="cylinder_count">
          <el-input v-model="onRoadForm.cylinder_count" type="number" clearable placeholder="请输入气缸数" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="发动机厂家" prop="engine_manufacturer">
          <el-input v-model="onRoadForm.engine_manufacturer" clearable placeholder="请输入发动机厂家" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="储能装置型号" prop="energy_storage_model">
          <el-input v-model="onRoadForm.energy_storage_model" clearable placeholder="请输入储能装置型号" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="电池容量" prop="battery_capacity">
          <el-input v-model="onRoadForm.battery_capacity" type="number" clearable placeholder="请输入电池容量" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="车辆生产企业" prop="vehicle_manufacturer">
          <el-input v-model="onRoadForm.vehicle_manufacturer" clearable placeholder="请输入车辆生产企业" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="车辆出厂日期" prop="manufacture_date">
          <el-date-picker
            v-model="onRoadForm.manufacture_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择车辆出厂日期"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="累计行驶里程（km）" prop="mileage">
          <el-input v-model="onRoadForm.mileage" type="number" clearable placeholder="请输入累计行驶里程" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="车主姓名（单位）" prop="owner_name">
          <el-input v-model="onRoadForm.owner_name" clearable placeholder="请输入车主姓名（单位）" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="联系电话" prop="owner_contact">
          <el-input v-model="onRoadForm.owner_contact" clearable placeholder="请输入联系电话" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="车牌颜色" prop="license_plate_color">
          <el-input v-model="onRoadForm.license_plate_color" clearable placeholder="请输入车牌颜色" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="燃料类型" prop="fuel_type">
          <el-input v-model="onRoadForm.fuel_type" clearable placeholder="请输入燃料类型" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="燃油型式" prop="fuel_style">
          <el-input v-model="onRoadForm.fuel_style" clearable placeholder="请输入燃油型式" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="驱动方式" prop="drive_mode">
          <el-input v-model="onRoadForm.drive_mode" clearable placeholder="请输入驱动方式" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="车辆品牌" prop="vehicle_brand">
          <el-input v-model="onRoadForm.vehicle_brand" clearable placeholder="请输入车辆品牌" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="变速器型式" prop="transmission_type">
          <el-input v-model="onRoadForm.transmission_type" clearable placeholder="请输入变速器型式" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="使用性质" prop="usage_nature">
          <el-input v-model="onRoadForm.usage_nature" clearable placeholder="请输入使用性质" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="初次登记日期" prop="initial_registration_date">
          <el-date-picker
            v-model="onRoadForm.initial_registration_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择初次登记日期"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="检测方法" prop="inspection_method">
          <el-select v-model="onRoadForm.inspection_method" placeholder="请选择检测方法">
            <el-option
              v-for="option in options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="OBD" prop="obd">
          <el-input v-model="onRoadForm.obd" clearable placeholder="请输入OBD" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-divider content-position="center">环境参数</el-divider>
    </el-col>
    <el-row>
      <el-col :span="8">
        <el-form-item label="环境温度（℃）" prop="ambient_temperature">
          <el-input v-model="onRoadForm.ambient_temperature" type="number" clearable placeholder="请输入环境温度" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="大气压（kPa）" prop="atmospheric_pressure">
          <el-input v-model="onRoadForm.atmospheric_pressure" type="number" clearable placeholder="请输入大气压" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="相对湿度（%RH）" prop="relative_humidity">
          <el-input v-model="onRoadForm.relative_humidity" type="number" clearable placeholder="请输入相对湿度" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-divider content-position="center">检测设备信息</el-divider>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="分析仪生产企业" prop="analyzer_manufacturer">
          <el-input v-model="onRoadForm.analyzer_manufacturer" clearable placeholder="请输入分析仪生产企业" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="分析仪型号/编号" prop="analyzer_model">
          <el-input v-model="onRoadForm.analyzer_model" clearable placeholder="请输入分析仪型号/编号" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="检定/校准有效期至" prop="verification_expiration">
          <el-date-picker
            v-model="onRoadForm.verification_expiration"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择检定/校准有效期至"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-divider content-position="center">检测内容</el-divider>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form-item label="额定转速(r/min)" prop="rated_rpm">
          <el-input v-model="onRoadForm.rated_rpm" type="number" clearable placeholder="请输入额定转速" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="实测转速(r/min)" prop="measured_rpm">
          <el-input v-model="onRoadForm.measured_rpm" type="number" clearable placeholder="请输入实测转速" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <el-form-item label="烟度测量值（m⁻¹）1" prop="opacity_value1">
          <el-input v-model="onRoadForm.opacity_value1" type="number" clearable placeholder="请输入烟度测量值" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="烟度测量值（m⁻¹）2" prop="opacity_value2">
          <el-input v-model="onRoadForm.opacity_value2" type="number" clearable placeholder="请输入烟度测量值" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="烟度测量值（m⁻¹）3" prop="opacity_value3">
          <el-input v-model="onRoadForm.opacity_value3" type="number" clearable placeholder="请输入烟度测量值" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form-item label="平均值（m⁻¹）" prop="average_opacity">
          <el-input v-model="onRoadForm.average_opacity" type="number" clearable placeholder="请输入平均值" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="限值（m⁻¹）" prop="limit_value">
          <el-input v-model="onRoadForm.limit_value" type="number" clearable placeholder="请输入限值" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-divider content-position="center">检测结果</el-divider>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-form-item label="检测结果" prop="inspection_result">
          <el-radio-group v-model="onRoadForm.inspection_result">
            <el-radio label="合格">合格</el-radio>
            <el-radio label="不合格">不合格</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-divider content-position="center">车辆照片</el-divider>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-form-item label="车辆照片" prop="vehicle_photo">
          <el-upload
            ref="vehicle_photo"
            action=""
            accept="image/*"
            list-type="picture-card"
            :limit="4"
            :file-list="fileList"
            :with-credentials="true"
            :before-upload="handleBeforeUpload"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadOnError"
            :http-request="uploadFile"
          >
            <i class="el-icon-plus" />
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" :loading="loading" @click="submit">{{ $t('common.save') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { uploadBase64, upload } from '@/api/common'
import { updateOnRoad, detailOnRoad } from '@/api/approver'
import { getToken } from '@/utils/auth'
import { pcTextArr } from 'element-china-area-data'
export default {
  name: 'EditOnRoad',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      id: 0,
      pcTextArr,
      options: [{
        value: '不透光烟度法（自由加速）',
        label: '不透光烟度法（自由加速）'
      }, {
        value: '自由加速法',
        label: '自由加速法'
      }],
      rules: {
        report_number: [
          { required: true, message: '请输入检测报告编号', trigger: 'blur' }
        ],
        inspection_date: [
          { required: true, message: '请选择检测日期', trigger: 'change' }
        ],
        inspection_location_address: [
          { required: true, message: '请输入检测地点', trigger: 'change' }
        ],
        license_plate_number: [
          { required: true, message: '请输入号牌号码', trigger: 'blur' }
        ],
        vehicle_model: [
          { required: true, message: '请输入车辆型号', trigger: 'blur' }
        ],
        vehicle_identification_number: [
          { required: true, message: '请输入车辆识别代码（VIN）', trigger: 'blur' }
        ],
        max_design_mass: [
          { required: true, message: '请输入最大设计总质量', trigger: 'blur' }
        ],
        engine_number: [
          { required: true, message: '请输入发动机号码', trigger: 'blur' }
        ],
        owner_name: [
          { required: true, message: '请输入车主姓名（单位）', trigger: 'blur' }
        ],
        owner_contact: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        license_plate_color: [
          { required: true, message: '请输入车牌颜色', trigger: 'blur' }
        ],
        fuel_type: [
          { required: true, message: '请输入燃料类型', trigger: 'blur' }
        ],
        vehicle_brand: [
          { required: true, message: '请输入车辆品牌', trigger: 'blur' }
        ],
        usage_nature: [
          { required: true, message: '请输入使用性质', trigger: 'blur' }
        ],
        initial_registration_date: [
          { required: true, message: '请选择初次登记日期', trigger: 'change' }
        ],
        inspection_method: [
          { required: true, message: '请输入检测方法', trigger: 'blur' }
        ],
        ambient_temperature: [
          { required: true, message: '请输入环境温度', trigger: 'blur' }
        ],
        atmospheric_pressure: [
          { required: true, message: '请输入大气压', trigger: 'blur' }
        ],
        relative_humidity: [
          { required: true, message: '请输入相对湿度', trigger: 'blur' }
        ],
        analyzer_manufacturer: [
          { required: true, message: '请输入分析仪生产企业', trigger: 'blur' }
        ],
        analyzer_model: [
          { required: true, message: '请输入分析仪型号/编号', trigger: 'blur' }
        ],
        verification_expiration: [
          { required: true, message: '请选择检定/校准有效期至', trigger: 'change' }
        ],
        opacity_value1: [
          { required: true, message: '请输入烟度测量值1', trigger: 'blur' }
        ],
        opacity_value2: [
          { required: true, message: '请输入烟度测量值2', trigger: 'blur' }
        ],
        opacity_value3: [
          { required: true, message: '请输入烟度测量值3', trigger: 'blur' }
        ],
        average_opacity: [
          { required: true, message: '请输入平均值', trigger: 'blur' }
        ],
        limit_value: [
          { required: true, message: '请输入限值', trigger: 'blur' }
        ],
        inspection_result: [
          { required: true, message: '请选择检测结果', trigger: 'change' }
        ]
      },
      onRoadForm: {
        report_number: '',
        inspection_date: '',
        inspection_location: [],
        inspection_location_address: '',
        license_plate_number: '',
        vehicle_model: '',
        base_mass: '',
        vehicle_identification_number: '',
        max_design_mass: '',
        engine_model: '',
        engine_number: '',
        engine_displacement: '',
        rated_speed: '',
        rated_power: '',
        dpf: '',
        dpf_model: '',
        scr: '',
        scr_model: '',
        cylinder_count: '',
        engine_manufacturer: '',
        energy_storage_model: '',
        battery_capacity: '',
        vehicle_manufacturer: '',
        manufacture_date: '',
        mileage: '',
        owner_name: '',
        owner_contact: '',
        license_plate_color: '',
        fuel_type: '',
        fuel_style: '',
        drive_mode: '',
        vehicle_brand: '',
        transmission_type: '',
        usage_nature: '',
        initial_registration_date: '',
        inspection_method: '',
        obd: '',
        ambient_temperature: '',
        atmospheric_pressure: '',
        relative_humidity: '',
        analyzer_manufacturer: '',
        analyzer_model: '',
        verification_expiration: '',
        rated_rpm: '',
        measured_rpm: '',
        opacity_value1: '',
        opacity_value2: '',
        opacity_value3: '',
        average_opacity: '',
        limit_value: '',
        inspection_result: '',
        vehicle_photo: []
      },
      fileList: [],
      uploadUrl: process.env.VUE_APP_API + '/common/upload',
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true) {
          this.id = val.id
          this.fetchData(val.id)
        }
      },
      deep: true
    }
  },
  created() {
    const id = this.item.id
    this.id = id
    this.fetchData(id)
  },
  methods: {
    fetchData(id) {
      this.resultImg = ''
      detailOnRoad(id).then(response => {
        this.onRoadForm = response.data
        this.fileList = this.onRoadForm.vehicle_photo.map(item => {
          return {
            name: item,
            url: process.env.VUE_APP_BASE_URL + item
          }
        })
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.onRoadForm.inspection_location.length === 0) {
            this.$message.error('请选择检测地点')
            return
          }
          // 车辆照片
          if (this.onRoadForm.vehicle_photo.length === 0) {
            this.$message.error('请上传车辆照片')
            return
          }
          // 签名
          // if (!this.onRoadForm.user_sign) {
          //   this.$message.error('请签名')
          //   return
          // }
          this.loading = true
          this.onRoadForm.id = this.id
          updateOnRoad(this.onRoadForm).then(response => {
            this.loading = false
            this.$message.success('保存成功')
            this.$emit('success:edit')
          }).catch(error => {
            console.log(error)
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    handleBeforeUpload(file) {
      // 只要是图片格式就可以上传
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGIF = file.type === 'image/gif'
      const isBMP = file.type === 'image/bmp'
      const isLt2M = file.size / 1024 / 1024 < 6
      if (!(isJPG || isPNG || isGIF || isBMP)) {
        this.$message.error('上传图片只能是 JPG/PNG/GIF/BMP 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 6MB!')
      }
      return (isJPG || isPNG || isGIF || isBMP) && isLt2M
    },
    handleRemove(file, fileList) {
      this.onRoadForm.vehicle_photo = fileList.map(item => item.name)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleUploadSuccess(response) {
      // 上传成功将返回的图片地址放入form中
      this.onRoadForm.vehicle_photo.push(response.data.path)
    },
    handleUploadOnError() {
      this.$message.error('上传失败')
    },
    handleReset() {
      this.$refs.esign.reset()
    },
    uploadFile(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      return upload(formData)
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        this.resultImg = res
        uploadBase64({
          file: res
        }).then(response => {
          this.onRoadForm.user_sign = response.data.path
        })
      }).catch(err => {
        alert(err) // 画布没有签字时会执行这里 'Not Signned'
      })
    },
    handleResetSign() {
      this.resultImg = ''
      this.$refs.esign.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-btn {
  margin-top: 10px;
  margin-left: 10px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}
</style>
